import { NSARouterMakerResult } from "namirasoft-account-react";
import { FieldProps } from "../FieldProps";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";

interface CategoryViewPageProps extends NSARouterMakerResult, FieldProps
{ }

export default function CategoryViewPage(props: CategoryViewPageProps)
{
	return (
		<FieldLayout
			{...props}
			action={{
				description: "This section displays detailed information about a selected category."
			}}
			pages={{
				entity: FieldEntities.category(props),
				view: {
				}
			}}
		>
			<> </>
		</FieldLayout>
	);
}